/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type StartSageIntacctRecipesInput = {
    sageIntacctTimeRegsFromForecast?: boolean | null | undefined;
    sageServiceForTimeRegsFeatureFlag?: boolean | null | undefined;
    sageServiceForTasksFeatureFlag?: boolean | null | undefined;
    sageServiceForProjectsFeatureFlag?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type startSageIntacctRecipesMutationVariables = {
    input: StartSageIntacctRecipesInput;
};
export type startSageIntacctRecipesMutationResponse = {
    readonly startSageIntacctRecipes: {
        readonly outcome: string | null;
    } | null;
};
export type startSageIntacctRecipesMutation = {
    readonly response: startSageIntacctRecipesMutationResponse;
    readonly variables: startSageIntacctRecipesMutationVariables;
};



/*
mutation startSageIntacctRecipesMutation(
  $input: StartSageIntacctRecipesInput!
) {
  startSageIntacctRecipes(input: $input) {
    outcome
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "StartSageIntacctRecipesInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartSageIntacctRecipesPayload",
    "kind": "LinkedField",
    "name": "startSageIntacctRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "startSageIntacctRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "startSageIntacctRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "startSageIntacctRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation startSageIntacctRecipesMutation(\n  $input: StartSageIntacctRecipesInput!\n) {\n  startSageIntacctRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ccfb72ca74df6552fcd29d748b71a1cf';
export default node;
